(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldWysiwyg', fbFieldWysiwyg);

    function fbFieldWysiwyg($timeout) {
        return {
            restrict: 'E',
            scope: {
                element: "=",
                model: '='
            },
            // require: ['ngModel'],
            controller: fbFieldWysiwygCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/libraries/formBuilder/fields/fieldWysiwyg',
        };
    }

    function fbFieldWysiwygCtrl(lodash, FormBuilderService, $scope, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);

            // const plugins = ['', ]

            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');

            vm.tinymceOptions = angular.merge(
                {},
                {
                    plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                    menubar: false,
                    toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent | alignleft aligncenter alignright alignjustify',
                    preview_styles: false,
                    resize: true,
                    statusbar: false,
                    autoresize_bottom_margin: 0,
                    autoresize_min_height: 50,
                    debounce: false,
                    // skin_url: cdnEp + '/assets/js/skins/lightgray',
                    content_css: cdnEp + '/assets/css/rms-tinymce.css',
                    // paste_as_text: true,
                    paste_data_images: false
                    // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
                },
                lodash.get(vm.element, 'options.tinymce', {}),
                {
                    setup: function (ed) {
                        vm.ed = ed;
                        ed.on('blur', function () {
                            vm.onEventTrigger('onBlur');
                        });
                        ed.on('init', function () {
                            $timeout(function () {
                                vm.pageData.currentScope.form.$setPristine();
                                vm.pageData.currentScope.form.$setUntouched();

                                $timeout(function () {
                                    var em = $element.find('.mce-toolbar-grp');
                                    $element.remove('.mce-toolbar-grp');
                                    $element.find('.mce-edit-area').after(em);
                                });
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    ed.setMode('readonly');
                                }
                            });
                        });
                        ed.on('PastePreProcess', function (e) {
                            // console.log('before');
                            // console.log(e.content);
                            var content_tmp = $("<div>");
                            content_tmp.html(e.content);
                            var s = new Sanitize(Sanitize.Config.RELAXED);
                            content_tmp.html(s.clean_node(content_tmp[0]));
                            e.content = content_tmp.html();

                            // console.log('after');
                            // console.log(e.content);
                        });
                    },
                    paste_preprocess: function (plugin, args) {
                        args.content = args.content.replace(/(<br[\s\/]*>)/g, '');

                        var pasteDataImages = lodash.get(vm.element, 'options.tinymce.paste_data_images', false);
                        if (pasteDataImages) {
                            var doc = new DOMParser().parseFromString(args.content, "text/html");

                            var toDataURL = function (url, callback) {
                                var xhr = new XMLHttpRequest();
                                xhr.onload = function () {
                                    var reader = new FileReader();
                                    reader.onloadend = function () {
                                        callback(reader.result);
                                    }
                                    reader.readAsDataURL(xhr.response);
                                };
                                xhr.open('GET', url);
                                xhr.withCredentials = "true";
                                xhr.responseType = 'blob';
                                xhr.send();

                                // function readResponseAsBlob(response) {
                                //     return response.blob();
                                // }


                                // fetch(url, {
                                //     credentials: "include",
                                //     mode: 'no-cors'
                                // }).then(readResponseAsBlob).then(function (response) {
                                //     var imgUrl = URL.createObjectURL(response);
                                //     callback(imgUrl);
                                //     console.log(response.type); // "opaque"
                                // }).catch(function (response) {
                                //     console.log(response.type); // "opaque"
                                // });


                            }

                            doc.querySelectorAll('img').forEach(function (elm) {
                                var src = elm.getAttribute('src');

                                const dataImageRegex = RegExp('^data:image/', 'ig');
                                var isBlob = dataImageRegex.test(src);
                                if (!isBlob) {
                                    toDataURL(elm.getAttribute('src'), function (result) {
                                        var content = vm.ed.getContent();
                                        var regExpSrc = new RegExp(src, 'ig');
                                        content = content.replace(regExpSrc, result);
                                        vm.ed.setContent(content);
                                    });
                                }
                            });
                        }
                    }
                }
            );
        }
    }
})();
